var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "current"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5057_32910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8 23.3866C35.3521 21.1169 34.1301 19.0731 32.3428 17.6042C30.5554 16.1354 28.3135 15.3327 26 15.3333C22.1467 15.3333 18.8 17.5199 17.1333 20.7199C15.1736 20.9317 13.3613 21.8602 12.0447 23.327C10.728 24.7938 9.99977 26.6955 10 28.6666C10 30.7883 10.8429 32.8232 12.3431 34.3234C13.8434 35.8237 15.8783 36.6666 18 36.6666H35.3333C36.2088 36.6666 37.0757 36.4941 37.8846 36.1591C38.6934 35.8241 39.4283 35.333 40.0474 34.714C40.6664 34.0949 41.1575 33.36 41.4925 32.5511C41.8276 31.7423 42 30.8754 42 29.9999C42 26.4799 39.2667 23.6266 35.8 23.3866ZM35.3333 33.9999H18C16.5855 33.9999 15.229 33.438 14.2288 32.4378C13.2286 31.4376 12.6667 30.0811 12.6667 28.6666C12.6667 25.9333 14.7067 23.6533 17.4133 23.3733L18.84 23.2266L19.5067 21.9599C20.1198 20.7663 21.0505 19.765 22.1962 19.0663C23.3418 18.3676 24.6581 17.9986 26 17.9999C29.4933 17.9999 32.5067 20.4799 33.1867 23.9066L33.5867 25.9066L35.6267 26.0533C36.629 26.1207 37.5686 26.5652 38.2563 27.2975C38.944 28.0298 39.3289 28.9953 39.3333 29.9999C39.3333 31.0608 38.9119 32.0782 38.1618 32.8283C37.4116 33.5785 36.3942 33.9999 35.3333 33.9999ZM20.6667 27.3333H24.0667V31.3333H27.9333V27.3333H31.3333L26 21.9999L20.6667 27.3333Z",
    fill: "#05668D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5057_32910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.8e455b82a6ab3a37798e26b2d13db9ff.svg";
export { ForwardRef as ReactComponent };